import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CardDetailState {
    data: any;
}

const initialState: CardDetailState = {
    data: null
};

const cardDetailSlice = createSlice({
    name: 'cardDetail',
    initialState,
    reducers: {
        setCardDetail: (state, action: PayloadAction<any>) => {
            state.data = action.payload;
        },
        updateCardDetail: (state, action: PayloadAction<any>) => {
            state.data = action.payload;
        }
    }
});

export const { setCardDetail, updateCardDetail } = cardDetailSlice.actions;
export default cardDetailSlice.reducer; 